module.exports = __webpack_public_path__ + "static/img/1.18afb07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/1.png
// module id = WKhn
// module chunks = 0